import { FunctionComponent } from 'react'

import styled from 'styled-components'

import translate from '@i18n'

import ChatbotArticleSlider from '../ChatbotArticleSlider'
import { chatbotRevealAnimation } from '../loading/QuestionLoadedAnimation'
import AnswerChatbotFeedback from './AnswerChatbotFeedback'

import type { AnswerFooterProps } from '../types'

const StyledArticleSliderWrapper = styled.div`
  ${chatbotRevealAnimation}
`

const AnswerFooter: FunctionComponent<AnswerFooterProps> = ({
  answer,
  activeIndex,
  showUserSnapRating = true,
  onSlideClick,
}) => {
  return (
    <>
      {answer.links && !!Object.keys(answer.links).length && (
        <StyledArticleSliderWrapper>
          <ChatbotArticleSlider
            links={answer.links}
            activeIndex={activeIndex}
            title={translate('summary.sources.title')}
            onSlideClick={onSlideClick}
          />
        </StyledArticleSliderWrapper>
      )}

      {showUserSnapRating && <AnswerChatbotFeedback message={answer} />}
    </>
  )
}

export default AnswerFooter
